import {useSubheader} from "../../../_metronic/layout";
import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import makeRequest, {makeFormDataRequest} from "../../api/makeRequest";
import Select from "react-select";


export const NewFilePage = () => {
	const { t } = useTranslation('common');
	const suhbeader = useSubheader();
	suhbeader.setTitle(t('UploadFile'));

	const [loading, setLoading] = useState(false);
	const [okMessage,setOkMessage] = useState('');

	const [file,setFile] = useState(null)
	const [isPublic,setIsPublic] = useState(true)
	const [roomId,setRoomId] = useState(null)

	const [rooms,setRooms] = useState([])

	useEffect(()=>{
		const getRoomsSimple = async () => {
			try {
				const {data} = await makeRequest('getRoomsSimple', {})
				const rooms = data.rooms
				setRooms(rooms)
			} catch (e) {
				console.log(e)
			}
		}

		getRoomsSimple()
	},[])

	const [status,setStatus] = useState("")
	const [errors,setErrors] = useState({})


	const enableLoading = () => {
		setLoading(true);
	};

	const disableLoading = () => {
		setLoading(false);
	};


	let history = useHistory();

	const handleSubmit = (e)=>{
		e.preventDefault()
		if (!file) {
			setErrors(prev=>({
				...prev,
				file2:t('SelectFile')
			}))
			return
		}
		if (!roomId) {
			setErrors(prev=>({
				...prev,
				room_id:t('ChooseRoom')
			}))
			return
		}

		enableLoading();
		const formData = new FormData()
		formData.append('file2',file)
		formData.append('isPublic',isPublic)
		formData.append('room_id',roomId)
		makeFormDataRequest('panel/import/file',formData )
			.then(({data}) => {
			const {success} = data
			if(success) {
				setOkMessage(t('FileAdded'))
				setTimeout(()=>{
					history.push('/file')
				},1000)
			}else{
				const {error} = data
				setStatus(error)
			}
		}).catch((e) => {
			setStatus(t('Error'))
		}).finally(() => {
			disableLoading();
		})
	}

	return (
		<>
			<form
				onSubmit={handleSubmit}
				className="form fv-plugins-bootstrap fv-plugins-framework"
			>
				{status ? (
					<div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
						<div className="alert-text font-weight-bold">{status}</div>
					</div>
				) : null}
				{okMessage ? (
					<div className="mb-10 alert alert-custom alert-light-success alert-dismissible">
						<div className="alert-text font-weight-bold">{okMessage}</div>
					</div>
				) : null}

				<div className="form-group fv-plugins-icon-container">
					<input
						type="file"
						className={`form-control form-control-solid h-auto py-5 px-6`}
						name="file2"
						onChange={(e)=>{

							if(e.target.files.length < 1){
								setErrors(prev=>({
									...prev,
									file2:t('SelectFile')
								}))
								setFile(null)
								e.target.value = null
								return;
							}

							const ext = e.target.files[0].name.toLowerCase()
							const allowed = [
								'xlsx','xls','jpg','jpeg','png','gif','mp4','webm','pdf','ppt','pps','ppsx','doc','docx',
								'mkv','avi','mp3','mpeg','wave','ogg','aac','zip','rar'
							]
							let okExt = false
							for(const allowExt of allowed){
								if(ext.includes(allowExt)){
									okExt = true
									break
								}
							}
							if(!okExt){
									setErrors(prev=>({
										...prev,
										file2:`{t('FormatGh)} -${allowed.toString()}`
									}))
								e.target.value = null
									return;
							}

							let lenMb = parseInt(e.target.files[0].size / 1024 / 1024 * 10)/10;

							if(lenMb > 500){
								setErrors(prev=>({
									...prev,
									file2:t('SizeMax500')
								}))
								e.target.value = null
								return;
							}
							setFile(e.target.files[0]);
						}}
					/>
					{errors.file2 ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{errors.file2}</div>
						</div>
					) : null}
				</div>
				<div className="form-group fv-plugins-icon-container">
					<label>{t('RoomName')}</label>
					<Select
						onChange={(e)=>{
							setRoomId(e.value)
						}}
						name='room_id'
						defaultValue={roomId}
						options={rooms.map(room=>({ value: room.public_id, label: room.name}))}
					/>
					{errors.room_id ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{errors.room_id}</div>
						</div>
					) : null}
				</div>
				<div className="form-group fv-plugins-icon-container">
					<label>{t('Downloadable')}</label>
					<input
						placeholder={t('Downloadable')}
						type="checkbox"
						className={`form-control text-center form-control-solid h-auto py-5 px-6 w-auto mx-10 d-inline-block`}
						name="isPublic"
						defaultChecked={isPublic}
						onChange={()=>{
							setIsPublic(prev=>!prev)
						}}
					/>
				</div>
				<div className="form-group d-flex flex-wrap justify-content-between align-items-center">
					<button
						id="kt_login_signin_submit"
						type="submit"
						disabled={loading}
						className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
					>
						<span>{t('UploadFile')}</span>
						{loading && <span className="blockui m-1 ml-3 spinner spinner-white"/>}
					</button>
				</div>
			</form>
		</>
	)
}
